import { render, staticRenderFns } from "./list.vue?vue&type=template&id=36622854&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=36622854&lang=scss"
import style1 from "./list.vue?vue&type=style&index=1&id=36622854&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36622854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36622854')) {
      api.createRecord('36622854', component.options)
    } else {
      api.reload('36622854', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=36622854&scoped=true", function () {
      api.rerender('36622854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cont/trends/list.vue"
export default component.exports